import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithMsalAuth } from "./baseApi";
import { InternalRole, InternalRolesAccess } from "@shared/models/userModels";

const controllerName = '/role'

export const rolesApi = createApi({
  reducerPath: 'rolesApi',
  baseQuery: baseQueryWithMsalAuth,
  endpoints: (builder) => ({
    getInternalRoles: builder.query<InternalRole[], void>({
      query: () => `${controllerName}/`,
    }),
    getInternalRolesPermissions: builder.query<InternalRolesAccess[], void>({
      query: () => `${controllerName}/permissions`,
    }),
  }),
});

 export const {
   useGetInternalRolesQuery,
   useLazyGetInternalRolesQuery,
   useGetInternalRolesPermissionsQuery,
   useLazyGetInternalRolesPermissionsQuery
 } = rolesApi;